import ISensediaToken from "../interfaces/ISensediaToken";
import ISensediaTokenResponse from "@/interfaces/ISensediaTokenResponse";
import apiSensedia from "./apiSensedia";
import { resources } from "./resources";

class SensediaService {
    getToken = async (obj: ISensediaToken) => {
        return await apiSensedia.post<ISensediaTokenResponse>(resources.sensediaAccessToken, obj);
    }
}

export default new SensediaService();